/* eslint-disable react/prop-types */
import React from 'react';

import { useCompanyHubPremiumGate } from '@confluence/company-hub/entry-points/useCompanyHubPremiumGate';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';
import {
	VIEW_PAGE,
	VIEW_BLOG_DATE_LEGACY,
	VIEW_BLOG,
	EDIT_PAGE_V2,
	EDIT_BLOG_V2,
} from '@confluence/named-routes';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { CompanyHomeBuilderUpsellPage } from '@confluence/change-edition/entry-points/CompanyHomeBuilderUpsellPage';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

import { ViewOrEditRoute } from './ViewOrEditRoute';

const LITE_ENABLED_ROUTES = [VIEW_PAGE.name, VIEW_BLOG_DATE_LEGACY.name, VIEW_BLOG.name];
const EDIT_V2_ROUTES = [EDIT_PAGE_V2.name, EDIT_BLOG_V2.name];

export const ContentRouteSelector = (props) => {
	const { name, params, query } = props;

	const isCompanyHub = isCompanyHubSpaceKey(params?.spaceKey);
	const shouldShowPremiumUpsell = useCompanyHubPremiumGate({
		skip: !isCompanyHub,
	});

	// Lite view
	const isLiteEnabledRoute = LITE_ENABLED_ROUTES.includes(name);
	const isViewPageLite = query?.lite && isLiteEnabledRoute;
	if (isViewPageLite) {
		return <ViewPageLiteRoute {...props} />;
	}

	// Company hub editor
	const isEditRoute = EDIT_V2_ROUTES.includes(name);
	if (isEditRoute && isCompanyHub && shouldShowPremiumUpsell) {
		return (
			<Screen screenEvent={{ name: '' }}>
				<MainLayout navView={PRODUCT_HOME_ID}>
					<CompanyHomeBuilderUpsellPage featureName="companyHub" />
				</MainLayout>
			</Screen>
		);
	}

	return <ViewOrEditRoute {...props} />;
};

export const ViewPageLiteRoute = LoadablePaint({
	// Name is used in next/packages/view-page/src/index.ts must match
	name: MustPreloadLoadableNames.ViewPageLiteRoute,
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPageLiteRoute" */ './ViewPageLiteRoute'))
			.ViewPageLiteRoute,
});
